import Layout from '@/libs/components/Layout'
import styles from './index.scss'
import { useState, useEffect } from 'react'
import { PullToRefresh, DatePicker } from 'antd-mobile'
import { memberPoint } from '@/services'
import { DownOutline } from 'antd-mobile-icons'
import moment from 'moment'

const GET = 'get'
const EXP = 'exp'

// 账单明细
export default function Bills() {
  const [activeKey, setActiveKey] = useState<string>(GET)
  const [inPoints, setInPoints] = useState([])
  const [outPoints, setoutPoints] = useState([])
  const [totalPoint, setTotalPoint] = useState<string>()
  const [year, setYear] = useState<string>(moment().format('YYYY'))
  const getListData = async () => {
    const res: any = await memberPoint({
      year: year,
    })
    const { inPoints, outPoints, totalPoint } = res
    setInPoints(inPoints)
    setoutPoints(outPoints)
    setTotalPoint(totalPoint)
  }

  useEffect(() => {
    getListData()
  }, [year])

  const NodataDom = (
    <div className={styles.nodata}>
      <img
        className={styles.icon}
        src={require('@/assets/image/personalCenter/empty-icon.png')}
      />
      <div className={styles.text}>暂无数据</div>
    </div>
  )

  return (
    <Layout title="积点明细">
      <PullToRefresh
        onRefresh={async () => {
          getListData()
        }}
      >
        <div className={styles.myPointPage}>
          <section className={styles.billsHeader}>
            <DatePicker
              title="选择年份"
              style={{
                '--adm-color-primary': '#F34242',
              }}
              precision="year"
              onConfirm={(date) => {
                setYear(moment(date).format('YYYY'))
              }}
            >
              {(_, actions) => (
                <div className={styles.year} onClick={actions.open}>
                  <span>{year}</span>
                  <DownOutline fontSize={14} color="#000000" />
                </div>
              )}
            </DatePicker>

            <p className={styles.num}>{totalPoint}</p>
            <p className={styles.tips}>可用有效积分</p>
          </section>
          <section className={styles.tabWrap}>
            <div className={styles.tabHeader}>
              <span
                className={activeKey === GET ? styles.active : styles.tabItem}
                onClick={() => {
                  setActiveKey(GET)
                }}
              >
                积分获取
              </span>
              <span
                className={activeKey === EXP ? styles.active : styles.tabItem}
                onClick={() => {
                  setActiveKey(EXP)
                }}
              >
                积分支出
              </span>
              <i
                className={`${activeKey === GET ? styles.pos1 : styles.pos2} ${
                  styles.tabBorder
                }`}
              />
            </div>

            {activeKey === GET && (
              <ul className={styles.listWrap}>
                {inPoints.length !== 0
                  ? inPoints.map((item: any, index: number) => (
                      <li className={styles.contentItem} key={index}>
                        <div className={styles.leftWrap}>
                          <p className={styles.title}>{item.remark}</p>
                          <p className={styles.date}>{item.createTime}</p>
                          <p className={styles.date}>
                            有效期：
                            {item.expirationType === 4
                              ? '永久有效'
                              : `${item.expirationStart ?? ''} 至 ${
                                  item.expirationEnd ?? ''
                                }`}
                          </p>
                        </div>
                        <div className={styles.rightWrap}>
                          <div className={styles.addCount}>+{item.opNum}</div>
                        </div>
                      </li>
                    ))
                  : NodataDom}
              </ul>
            )}
            {activeKey === EXP && (
              <ul className={styles.listWrap}>
                {outPoints.length !== 0
                  ? outPoints.map((item: any, index: number) => (
                      <li className={styles.contentItem} key={index}>
                        <div className={styles.leftWrap}>
                          <p className={styles.title}>{item.remark}</p>
                          <p className={styles.date}>{item.createTime}</p>
                        </div>
                        <div className={styles.count}>-{item.opNum}</div>
                      </li>
                    ))
                  : NodataDom}
              </ul>
            )}
          </section>
        </div>
      </PullToRefresh>
    </Layout>
  )
}
